import { dateService, FORMATS } from '@/global/services/date'
import { api } from '@/global/services/api'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import SessionGridBlock from '../../components/SessionGridBlock.vue'
import gridView from '@/global/components/grid/GridView.vue'
import sessionsMixin from '../../mixins/sessionsMixin'
import { deleteAction } from '@/global/components/table/helpers/tableActions'

const TAB_KEY = 'session'
export default {
  name: 'sessionTab',

  computed: {
    sessionTabConfig () {
      return {
        title: this.$t('base.sessions'),
        key: TAB_KEY,
        tabContent: [
          {
            component: this.tableGridContentComponent,
            editable: false,
            apiConfig: {
              get: {
                module: 'base',
                route: 'session'
              }
            },
            gridConfig: {
              component: gridView,
              blockConfig: {
                component: SessionGridBlock
              },
              useBorder: false
            },
            mobileConfig: {
              title: this.$t('base.sessions')
            },
            title_and_back_config: {
              title: this.$t('base.sessions')
            },
            search_and_buttons_config: {
              additional_buttons: [
                {
                  type: 'base',
                  label: this.$t('base/session.destroy_all_other'),
                  click: (event) => this.destroyAllOtherSessions(event)
                }
              ]
            },
            tableConfig: {
              cellsConfig: {
                last_activity: {
                  custom_display_value: (val) => {
                    return val && val.last_activity ? dateService.format(val.last_activity, FORMATS.datetime) : '-'
                  }
                },
                current_session: {
                  type: 'status',
                  displayValue: 'description',
                  colorObjectKey: 'color',
                  textColorKey: 'text',
                  backgroundColorKey: 'background'
                }
              },
              headers: [
                {
                  label: this.$t('base/session.ip_address'),
                  key: 'ip_address',
                  always_visible: true
                },
                {
                  label: this.$t('base/session.user_agent'),
                  key: 'user_agent',
                  always_visible: true
                },
                {
                  label: this.$t('base/session.last_activity'),
                  key: 'last_activity',
                  always_visible: true
                },
                {
                  label: this.$t('base/session.current_session'),
                  key: 'current_session',
                  always_visible: true
                }
              ],
              actionsConfig: [
                {
                  ...deleteAction(this.$t, (event) => this.onDeleteSession(event)),
                  type: 'delete'
                }
              ],
              filtersConfig: {
                fields: [
                  {
                    key: 'ip_address',
                    label: this.$t('base/session.ip_address')
                  },
                  {
                    key: 'user_agent',
                    label: this.$t('base/session.user_agent')
                  }
                ]
              },
              paginationConfig: {
                perPageOptions: [15, 50, 100, 200]
              }
            }
          }
        ]
      }
    }
  },

  mixins: [
    sessionsMixin
  ],

  methods: {
    async destroyAllOtherSessions (event) {
      try {
        this.$set(this.informationDialogData, 'message', this.$t('base/sessions.remove_all_sessions_confirmation_message'))
        this.$set(this.informationDialogData, 'cancelText', this.$t('base.cancel'))
        this.$set(this.informationDialogData, 'confirmText', this.$t('base.confirm'))
        this.$set(this.informationDialogData, 'title', this.$t('base/sessions.remove_all_sessions_confirmation_title'))
        this.$set(this.informationDialogData, 'callback', async () => await this.odDestroyAllOtherSessionsCallback(event))
        this.$set(this.informationDialogData, 'show', true)
      }
      catch (exception) {
        console.log(exception)
      }
    },

    async odDestroyAllOtherSessionsCallback () {
      try {
        const { fetchData } = registeredTableHandlers[TAB_KEY] || {}
        await api('base').delete('/session/all')

        this.$set(this.informationDialogData, 'show', false)
        // Refresh table data
        fetchData?.()
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
